import { render, staticRenderFns } from "./changeSalesman.vue?vue&type=template&id=264ebdc8&"
import script from "./changeSalesman.vue?vue&type=script&lang=js&"
export * from "./changeSalesman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports